<template>
  <div>
    <v-card-component v-if="isLoaded === true" :title="'Documents'" :icon="cardIcon">
      <v-row>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Student photo</span>
          <span class="error--text ml-1">*</span>
          <v-file-input
            :messages="['(max file size allowed 2MB)']"
            :required="isDocRequired"
            accept="image/jpeg"
            v-model="value.studentPhoto"
            single
            drag-drop
            @input="onFilechange('studentPhoto')"
            show-size
            placeholder="Accepts jpg, jpeg only"
          ></v-file-input>

          <v-chip color="primary" label outlined v-if="studentPhotoURL" class="ma-2" @click="downloadFile(studentPhotoURL)" close @click:close="deleteFile('studentPhoto')">
            Student Photo
          </v-chip>
        </v-col>

        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium"> Parent photo</span>
          <v-file-input
            :messages="['(max file size allowed 2MB)']"
            accept="image/jpeg"
            v-model="value.fatherPhoto"
            single
            drag-drop
            @input="onFilechange('fatherPhoto')"
            show-size
            placeholder="Accepts jpg, jpeg only"
          ></v-file-input>
          <v-chip @click="downloadFile(fatherPhotoURL)" v-if="fatherPhotoURL" color="primary" label outlined class="ma-2" close @click:close="deleteFile('fatherPhoto')">
            Parent Photo
          </v-chip>
        </v-col>

        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium"> Mother photo</span>
          <v-file-input
            :messages="['(max file size allowed 2MB)']"
            accept="image/jpeg"
            v-model="value.motherPhoto"
            single
            drag-drop
            @input="onFilechange('motherPhoto')"
            show-size
            placeholder="Accepts jpg, jpeg only"
          ></v-file-input>
          <v-chip @click="downloadFile(motherPhotoURL)" v-if="motherPhotoURL" color="primary" label outlined class="ma-2" close @click:close="deleteFile('motherPhoto')">
            Mother Photo
          </v-chip>
        </v-col>
      </v-row>
    </v-card-component>

    <v-card-component :title="cardTitle" :icon="cardIcon">
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Birth Certificate</span>
              <span class="error--text ml-1">*</span>
              <v-file-input
                :messages="['(max file size allowed 2MB)']"
                :required="isDocRequired"
                accept="image/jpeg, application/pdf"
                v-model="value.birthCertificate"
                single
                drag-drop
                @input="onFilechange('birthCertificate')"
                show-size
                placeholder="Accepts jpg, jpeg, pdf only"
              >
              </v-file-input>
              <v-chip @click="downloadFile(birthCertificateURL)" v-if="birthCertificateURL" color="primary" label outlined class="ma-2" close @click:close="deleteFile('birthCertificate')">
                Birth Certificate
              </v-chip>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Transfer Certificate</span>
              <v-file-input
                :messages="['(max file size allowed 2MB)']"
                accept="image/jpeg, application/pdf"
                v-model="value.transferCertificate"
                single
                drag-drop
                @input="onFilechange('transferCertificate')"
                show-size
                placeholder="Accepts jpg, jpeg, pdf only"
              >
              </v-file-input>
              <v-chip v-if="transferCertificateURL" @click="downloadFile(transferCertificateURL)" color="primary" label outlined class="ma-2" close @click:close="deleteFile('transferCertificate')">
                Transfer Certificate
              </v-chip>
            </v-col>

            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Immunisation Certificate</span><span class="error--text ml-1" v-if="formType === 'edit_registration'? false:isDocRequired">*</span>
              <v-file-input
                :messages="['(max file size allowed 2MB)']"
                accept="image/jpeg, application/pdf"
                v-model="value.immunisationCertificate"
                :required="formType === 'edit_registration'? false:isDocRequired"
                single
                drag-drop
                @input="onFilechange('immunisationCertificate')"
                show-size
                placeholder="Accepts jpg, jpeg, pdf only"
              ></v-file-input>
              <v-chip
                @click="downloadFile(immunisationCertificateURL)"
                v-if="immunisationCertificateURL"
                color="primary"
                label
                outlined
                class="ma-2"
                close
                @click:close="deleteFile('immunisationCertificate')"
              >
                Immunisation Certificate
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Student Aadhar Card</span> <span class="error--text ml-1" v-if="formType === 'edit_registration'? false:isDocRequired">*</span>
          <v-file-input
            :messages="['(max file size allowed 2MB)']"
            accept="image/jpeg, application/pdf"
            v-model="value.studentAadharCard"
            :required="formType === 'edit_registration'? false:isDocRequired"
            single
            drag-drop
            @input="onFilechange('studentAadharCard')"
            show-size
            placeholder="Accepts jpg, jpeg, pdf only"
          >
          </v-file-input>
          <v-chip @click="downloadFile(studentAadharCardURL)" v-if="studentAadharCardURL" color="primary" label outlined class="ma-2" close @click:close="deleteFile('studentAadharCard')">
            Student Aadhar Card
          </v-chip>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Parent Aadhar Card</span> <span class="error--text ml-1" v-if="formType === 'edit_registration'? false:isDocRequired">*</span>
          <v-file-input
            :messages="['(max file size allowed 2MB)']"
            accept="image/jpeg, application/pdf"
            v-model="value.fatherAadharCard"
            :required="formType === 'edit_registration'? false:isDocRequired"
            single
            drag-drop
            @input="onFilechange('fatherAadharCard')"
            show-size
            placeholder="Accepts jpg, jpeg, pdf only"
          >
          </v-file-input>
          <v-chip v-if="fatherAadharCardURL" @click="downloadFile(fatherAadharCardURL)" color="primary" label outlined class="ma-2" close @click:close="deleteFile('fatherAadharCard')">
            Parent Aadhar Card
          </v-chip>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Mother Aadhar Card</span> <span class="error--text ml-1" v-if="formType === 'edit_registration'? false:isDocRequired">*</span>
          <v-file-input
            :messages="['(max file size allowed 2MB)']"
            accept="image/jpeg, application/pdf"
            v-model="value.motherAadharCard"
            :required="formType === 'edit_registration'? false:isDocRequired"
            single
            drag-drop
            @input="onFilechange('motherAadharCard')"
            show-size
            placeholder="Accepts jpg, jpeg, pdf only"
          >
          </v-file-input>
          <v-chip v-if="motherAadharCardURL" color="primary" @click="downloadFile(motherAadharCardURL)" label outlined class="ma-2" close @click:close="deleteFile('motherAadharCard')">
            Mother Aadhar Card
          </v-chip>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Health Certificate</span>
          <v-file-input
            :messages="['(max file size allowed 2MB)']"
            accept="image/gif, image/jpeg, application/pdf"
            v-model="value.healthCertificate"
            single
            drag-drop
            @input="onFilechange('healthCertificate')"
            show-size
            placeholder="Accepts jpg, jpeg, pdf only"
          >
          </v-file-input>
          <v-chip @click="downloadFile(healthCertificateURL)" v-if="this.healthCertificateURL" color="primary" label outlined class="ma-2" close @click:close="deleteFile('healthCertificate')">
            Health Certificate
          </v-chip>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Special Education Needs (SEN) Certificate</span>
          <v-file-input
            :messages="['(max file size allowed 2MB)']"
            accept="image/gif, image/jpeg, application/pdf"
            v-model="value.senCertificate"
            single
            drag-drop
            @input="onFilechange('senCertificate')"
            show-size
            placeholder="Accepts jpg, jpeg, pdf only"
          >
          </v-file-input>
          <v-chip @click="downloadFile(senCertificateURL)" v-if="this.senCertificateURL" color="primary" label outlined class="ma-2" close @click:close="deleteFile('senCertificate')">
            Special Education Needs (SEN) Certificate
          </v-chip>
        </v-col>
      </v-row>
    </v-card-component>
  </div>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'

import moment from 'moment'
import constants from '@/utils/constants'
import _ from 'lodash'
import Utils from '@/utils'

export default {
  name: 'RegDocumentElement',
  props: {
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    },
    enquiryID: {
      default: '',
      type: String
    }
  },
  components: {
    VCardComponent
  },
  data: function () {
    return {
      isReadonly: false,
      isDisabled: false,
      required: true,
      cardTitle: '',
      cardIcon: '',
      maxToDate: moment().format('YYYY-MM-DD'),
      studentPhoto: '',
      fatherPhoto: '',
      motherPhoto: '',
      inputTitle: '',
      selectedDocType: '',
      formatMsg: '',
      s3keypath: '',
      studentPhotoURL: '',
      fatherPhotoURL: '',
      motherPhotoURL: '',
      birthCertificateURL: '',
      transferCertificateURL: '',
      immunisationCertificateURL: '',
      studentAadharCardURL: '',
      fatherAadharCardURL: '',
      motherAadharCardURL: '',
      healthCertificateURL: '',
      isLoaded: false,
      isRequired: true,
      studentPhotoURLs: '',
      isDocRequired: true,
      senCertificateURL: ''
    }
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },

  created: async function () {
    await this.loadImageURLs()
    this.isLoaded = true
    if (!_.isEmpty(this.value.studentPhotoUrl)) {
      this.isDocRequired = false
    }
  },
  methods: {
    validateFiles (files, extensions, limit, isMandatory) {
      try {
        if (isMandatory && _.isEmpty(files)) {
          this.errMsg(`File is required`)
        }
        if (_.isEmpty(extensions)) {
          this.errMsg(`Please provide valid extension list`)
        }
        let extensionsSet = extensions
        let limitDetails = limit.split(' ')
        let limitUnitList = ['B', 'KB', 'MB', 'GB']
        // Validate Limit
        if (!_.isEqual(limitDetails.length, 2) || _.isEqual(_.toNumber(limitDetails[0]), NaN) || !limitUnitList.has(limitDetails[1].toUpperCase())) {
          this.errMsg(`Invalid file size format`)
        }
        if (!_.isArray(files)) {
          files = [files]
        }
        let limitSize = limitDetails[0]
        let limitUnit = limitDetails[1].toUpperCase()
        let unitConvert
        switch (limitUnit) {
          case ' KB':
            unitConvert = 1024
            break
          case 'MB':
            unitConvert = Math.pow(1024, 2)
            break
          case 'GB':
            unitConvert = Math.pow(1024, 3)
            break
          default:
            unitConvert = 1
        }
        // Validate File
        _.forEach(files, file => {
          if (!extensionsSet.has(file.hapi.headers['content-type'].split('/')[1])) {
            this.errMsg(`File is acceptable in '${extensionsSet.join(',')}' format only!`)
          }
          const fSize = file._data.length
          const fileSize = Math.round(fSize / unitConvert)
          if (fileSize > limitSize) {
            this.errMsg(`File is too Big, please select file less than ${limitSize}${limitUnit}`)
          }
        })
        return {
          success: 200,
          message: `Files are valid`,
          data: { files, extensions, limit, isMandatory }
        }
      } catch (e) {
        console.log(e)
        throw e
      }
    },
    onFilechange (fileType) {
      let getFileType = ''
      switch (fileType) {
        case 'studentPhoto':
          getFileType = this.value.studentPhoto.type
          break
        case 'fatherPhoto':
          getFileType = this.value.fatherPhoto.type
          break
        case 'motherPhoto':
          getFileType = this.value.motherPhoto.type
          break
        case 'birthCertificate':
          getFileType = this.value.birthCertificate.type
          break
        case 'transferCertificate':
          getFileType = this.value.transferCertificate.type
          break
        case 'immunisationCertificate':
          getFileType = this.value.immunisationCertificate.type
          break
        case 'studentAadharCard':
          getFileType = this.value.studentAadharCard.type
          break
        case 'fatherAadharCard':
          getFileType = this.value.fatherAadharCard.type
          break
        case 'motherAadharCard':
          getFileType = this.value.motherAadharCard.type
          break
        case 'healthCertificate':
          getFileType = this.value.healthCertificate.type
          break
        case 'senCertificate':
          getFileType = this.value.senCertificate.type
          break
        default:
          break
      }
      if (getFileType !== 'application/pdf' && getFileType !== 'image/jpeg') {
        this.errMsg('Kindly select only .pdf or .jpeg/.jpg format file!')
        this.deleteDropFile(fileType)
      } else {
        return true
      }
    },
    deleteDropFile (fileType) {
      switch (fileType) {
        case 'studentPhoto':
          this.value.studentPhoto = [this.value.studentPhoto]
          this.value.studentPhoto.splice(0, 1)
          break
        case 'fatherPhoto':
          this.value.fatherPhoto = [this.value.fatherPhoto]
          this.value.fatherPhoto.splice(0, 1)
          break
        case 'motherPhoto':
          this.value.motherPhoto = [this.value.motherPhoto]
          this.value.motherPhoto.splice(0, 1)
          break
        case 'birthCertificate':
          this.value.birthCertificate = [this.value.birthCertificate]
          this.value.birthCertificate.splice(0, 1)
          break
        case 'transferCertificate':
          this.value.transferCertificate = [this.value.transferCertificate]
          this.value.transferCertificate.splice(0, 1)
          break
        case 'immunisationCertificate':
          this.value.immunisationCertificate = [this.value.immunisationCertificate]
          this.value.immunisationCertificate.splice(0, 1)
          break
        case 'studentAadharCard':
          this.value.studentAadharCard = [this.value.studentAadharCard]
          this.value.studentAadharCard.splice(0, 1)
          break
        case 'fatherAadharCard':
          this.value.fatherAadharCard = [this.value.fatherAadharCard]
          this.value.fatherAadharCard.splice(0, 1)
          break
        case 'motherAadharCard':
          this.value.motherAadharCard = [this.value.motherAadharCard]
          this.value.motherAadharCard.splice(0, 1)
          break
        case 'healthCertificate':
          this.value.healthCertificate = [this.value.healthCertificate]
          this.value.healthCertificate.splice(0, 1)
          break
        case 'senCertificate':
          this.value.senCertificate = [this.value.senCertificate]
          this.value.senCertificate.splice(0, 1)
          break
        default:
          break
      }
    },
    deleteFile (fileType) {
      if (confirm('Do you really want to remove this document?')) {
        switch (fileType) {
          case 'studentPhoto':
            this.studentPhotoURL = this.value.studentPhotoUrl = ''
            break
          case 'fatherPhoto':
            this.fatherPhotoURL = this.value.fatherPhotoUrl = ''
            break
          case 'motherPhoto':
            this.motherPhotoURL = this.value.motherPhotoUrl = ''
            break
          case 'birthCertificate':
            this.birthCertificateURL = this.value.birthCertificateUrl = ''
            break
          case 'transferCertificate':
            this.transferCertificateURL = this.value.transferCertificateUrl = ''
            break
          case 'immunisationCertificate':
            this.immunisationCertificateURL = this.value.immunisationCertificateUrl = ''
            break
          case 'studentAadharCard':
            this.studentAadharCardURL = this.value.studentAadharCardUrl = ''
            break
          case 'fatherAadharCard':
            this.fatherAadharCardURL = this.value.fatherAadharCardUrl = ''
            break
          case 'motherAadharCard':
            this.motherAadharCardURL = this.value.motherAadharCardUrl = ''
            break
          case 'healthCertificate':
            this.healthCertificateURL = this.value.healthCertificateUrl = ''
            break
          case 'senCertificate':
            this.senCertificateURL = this.value.senCertificateUrl = ''
            break
          default:
            break
        }
      } else {
        return false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },

    downloadFile: async function (key) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await http
          .get(`${constants.API_URL}/api/download-document?s3urlKey=${key}`)
          .then(response => {
            window.open(response.data, '_blank')
          })
          .catch(httpException => {
            return Utils.notify(httpException.message, 'error')
          })
        this.loadingComponent.close()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        console.log('error in fetching records : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getS3Url: async function (key) {
      await http
        .get(`${constants.API_URL}/api/ticket/downloadurl?s3urlKey=${key}`)
        .then(response => {
          return response.data
        })
        .catch(httpException => {
          return Utils.notify(httpException.message, 'error')
        })
    },
    loadImageURLs: async function () {
      this.studentPhotoURL = !_.isEmpty(this.value.studentPhotoUrl) && this.value.studentPhotoUrl !== '0' ? this.value.studentPhotoUrl : ''
      this.fatherPhotoURL = !_.isEmpty(this.value.fatherPhotoUrl) && this.value.fatherPhotoUrl !== '0' ? this.value.fatherPhotoUrl : ''
      this.motherPhotoURL = !_.isEmpty(this.value.motherPhotoUrl) && this.value.motherPhotoUrl !== '0' ? this.value.motherPhotoUrl : ''
      this.birthCertificateURL = !_.isEmpty(this.value.birthCertificateUrl) && this.value.birthCertificateUrl !== '0' ? this.value.birthCertificateUrl : ''
      this.transferCertificateURL = !_.isEmpty(this.value.transferCertificateUrl) && this.value.transferCertificateUrl !== '0' ? this.value.transferCertificateUrl : ''
      this.immunisationCertificateURL = !_.isEmpty(this.value.immunisationCertificateUrl) && this.value.immunisationCertificateUrl !== '0' ? this.value.immunisationCertificateUrl : ''
      this.studentAadharCardURL = !_.isEmpty(this.value.studentAadharCardUrl) && this.value.studentAadharCardUrl !== '0' ? this.value.studentAadharCardUrl : ''
      this.fatherAadharCardURL = !_.isEmpty(this.value.fatherAadharCardUrl) && this.value.fatherAadharCardUrl !== '0' ? this.value.fatherAadharCardUrl : ''
      this.motherAadharCardURL = !_.isEmpty(this.value.motherAadharCardUrl) && this.value.motherAadharCardUrl !== '0' ? this.value.motherAadharCardUrl : ''
      this.healthCertificateURL = !_.isEmpty(this.value.healthCertificateUrl) && this.value.healthCertificateUrl !== '0' ? this.value.healthCertificateUrl : ''
      this.senCertificateURL = !_.isEmpty(this.value.senCertificateUrl) && this.value.senCertificateUrl !== '0' ? this.value.senCertificateUrl : ''
      if (this.isWritable === 'false') {
        this.isReadonly = true
        this.isDisabled = true
      }
      if (this.studentPhotoURL) {
        this.isLoaded = true
      }
      this.cardTitle = 'Document Upload'
      this.cardIcon = 'mdi-file-upload'
    }
  }
}
</script>
